// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  border-top: 1px solid #f3f4f6;
}
.footer .mainFooter {
  background-color: #ffffff;
  padding: 30px 20px;
  max-width: 1200px;
  margin: 0 auto;
}
.footer .mainFooter .footerContent {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1.5fr 1fr 1fr 1.2fr;
  grid-gap: 40px;
  gap: 40px;
}
@media (max-width: 768px) {
  .footer .mainFooter .footerContent {
    grid-template-columns: 1fr 1fr;
    gap: 20px;
  }
  .footer .mainFooter .footerContent > :first-child {
    grid-column: 1/-1;
  }
}
.footer .mainFooter .footerCol {
  display: flex;
  flex-direction: column;
  gap: 15px;
}
@media (max-width: 575px) {
  .footer .mainFooter .footerCol {
    gap: 10px;
  }
}
.footer .mainFooter .footerCol h3 {
  font-size: 16px;
  font-weight: 700;
  color: #111827;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  height: 35px;
}
@media (max-width: 575px) {
  .footer .mainFooter .footerCol h3 {
    font-size: 14px;
    height: auto;
  }
}
.footer .mainFooter .footerCol .footerBrandLogo img {
  height: 35px;
}
.footer .mainFooter .footerCol .description {
  font-size: 14px;
  line-height: 1.6;
  color: #4b5563;
}
.footer .mainFooter .footerCol .linkItem {
  font-size: 14px;
  color: #374151;
  text-decoration: none;
  cursor: pointer;
  line-height: 1.4;
  transition: color 0.2s ease;
}
.footer .mainFooter .footerCol .linkItem:hover {
  color: #EA2466;
}
.footer .mainFooter .footerCol .linkItem a {
  text-decoration: none;
  color: inherit;
}
.footer .subFooter {
  background-color: #ffffff;
  padding: 20px;
  border-top: 1px solid #f3f4f6;
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
}
@media (max-width: 768px) {
  .footer .subFooter {
    flex-direction: column-reverse;
    gap: 20px;
  }
}
.footer .subFooter .copyright {
  font-size: 13px;
  color: #6b7280;
}
@media (max-width: 768px) {
  .footer .subFooter .copyright {
    text-align: center;
  }
}
.footer .subFooter .socialLinks {
  display: flex;
  gap: 12px;
}
.footer .subFooter .socialLinks .logoContainer {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid #d1d5db;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.2s ease;
}
.footer .subFooter .socialLinks .logoContainer svg {
  width: 20px;
  height: 20px;
}
.footer .subFooter .socialLinks .logoContainer:hover {
  background-color: #f3f4f6;
  border-color: #EA2466;
}

.footerErrorMessage {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

@media (max-width: 768px) {
  body.rewardListingMobileTabsActive .footerBrandingOnly {
    --mobile-fixed-footer-offset: 70px;
  }
  body.rewardDetailMobileActionActive .footerBrandingOnly {
    --mobile-fixed-footer-offset: 90px;
  }
  body.rewardDetailMobileCompletedActionActive .footerBrandingOnly {
    --mobile-fixed-footer-offset: 120px;
  }
  body.rewardDetailMobileActionExpanded .footerBrandingOnly,
  body.rewardDetailGiftCardAmountSheetActive .footerBrandingOnly,
  body.rewardDetailMobileRecipientSheetActive .footerBrandingOnly {
    --mobile-fixed-footer-offset: 240px;
  }
}
.footerBrandingOnly {
  background-color: #1E1E1E;
  background-color: var(--footerBrandingOnlyBg, #1E1E1E);
  color: #ffffff;
}
@media (max-width: 768px) {
  .footerBrandingOnly {
    padding-bottom: calc(0px + env(safe-area-inset-bottom));
    padding-bottom: calc(var(--mobile-fixed-footer-offset, 0px) + env(safe-area-inset-bottom));
  }
}
.footerBrandingOnly .footerContactMobile {
  display: none;
}
@media (max-width: 768px) {
  .footerBrandingOnly .footerContactMobile {
    display: block;
    padding: 16px 20px 0;
  }
}
.footerBrandingOnly .footerContactMobile .contactRow {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 12px;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.footerBrandingOnly .footerContactMobile .contactRow:last-child {
  margin-bottom: 16px;
}
@media (max-width: 575px) {
  .footerBrandingOnly .footerContactMobile .contactRow {
    gap: 12px;
    align-items: flex-start;
  }
}
.footerBrandingOnly .footerContactMobile .contactItem {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
}
.footerBrandingOnly .footerContactMobile .contactItem a {
  color: #ffffff;
  text-decoration: none;
}
.footerBrandingOnly .footerContactMobile .contactItem a:hover {
  text-decoration: underline;
}
.footerBrandingOnly .footerContactMobile .contactUsBtn {
  background: transparent;
  color: #ffffff;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s ease;
}
.footerBrandingOnly .footerContactMobile .contactUsBtn:hover {
  text-decoration: underline;
}
.footerBrandingOnly .customerSupport {
  background: transparent;
  color: #ffffff;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 4px;
  transition: all 0.3s ease;
  width: -webkit-fit-content;
  width: fit-content;
}
.footerBrandingOnly .customerSupport:hover {
  text-decoration: underline;
}
.footerBrandingOnly .brandingDiv {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 12px;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}
@media (max-width: 768px) {
  .footerBrandingOnly .brandingDiv {
    justify-content: center;
    flex-direction: column;
    gap: 0;
    padding: 4px 12px;
  }
}
.footerBrandingOnly .brandingDiv .brandingLogoSection {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-shrink: 0;
}
.footerBrandingOnly .brandingDiv .footerContactDesktop {
  display: flex;
  align-items: flex-end;
  gap: 24px;
}
@media (max-width: 768px) {
  .footerBrandingOnly .brandingDiv .footerContactDesktop {
    display: none;
  }
}
.footerBrandingOnly .brandingDiv .footerContactDesktop .contactItem {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
}
.footerBrandingOnly .brandingDiv .footerContactDesktop .contactItem a {
  color: #ffffff;
  text-decoration: none;
}
.footerBrandingOnly .brandingDiv .footerContactDesktop .contactItem a:hover {
  text-decoration: underline;
}
.footerBrandingOnly .brandingDiv .footerContactDesktop .contactUsBtn {
  background: transparent;
  color: #ffffff;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s ease;
  margin-left: 8px;
}
.footerBrandingOnly .brandingDiv .footerContactDesktop .contactUsBtn:hover {
  text-decoration: underline;
}
.footerBrandingOnly .brandingDiv .poweredByContainer {
  display: flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
}
.footerBrandingOnly .brandingDiv .poweredBy {
  display: flex;
  width: 100%;
  justify-content: flex-end;
  align-items: center;
  font-size: 12px;
  gap: 4px;
}
@media (max-width: 768px) {
  .footerBrandingOnly .brandingDiv .poweredBy {
    font-size: 10px;
  }
}
.footerBrandingOnly .brandingDiv .whiteAdentoText {
  font-size: 20px;
  font-weight: 700;
  color: #ffffff;
  width: 90px;
  height: 44px;
}
.footerBrandingOnly .brandingDiv .whiteAdentoText img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.footerBrandingOnly .brandingDiv .brandLogo {
  margin-right: 6px;
  max-height: 40px;
  max-width: 100px;
}
.footerBrandingOnly .brandingDiv .brandingContent {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
}
.footerBrandingOnly .brandingDiv .brandingContent .poweredByContainer {
  width: 100%;
  justify-content: flex-end;
}
@media (max-width: 768px) {
  .footerBrandingOnly .brandingDiv .brandingContent .poweredByContainer {
    align-items: center;
    flex-direction: row;
    font-size: 8px;
    gap: 4px;
    width: auto;
  }
}
.footerBrandingOnly .brandingDiv.brandingInfoOnlyLayout {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  grid-column-gap: 32px;
  column-gap: 32px;
  align-items: center;
  justify-content: stretch;
}
@media (max-width: 768px) {
  .footerBrandingOnly .brandingDiv.brandingInfoOnlyLayout {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 12px;
  }
}
.footerBrandingOnly .brandingDiv.brandingInfoOnlyLayout .footerContactDesktop {
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  min-width: 0;
}
.footerBrandingOnly .brandingDiv.brandingInfoOnlyLayout .footerContactDesktop .contactBox {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex-shrink: 0;
}
.footerBrandingOnly .brandingDiv.brandingInfoOnlyLayout .poweredByContainer {
  justify-self: end;
  margin-left: auto;
}
@media (max-width: 768px) {
  .footerBrandingOnly .brandingDiv.brandingInfoOnlyLayout .poweredByContainer {
    flex-direction: column;
    gap: 0;
    font-size: 10px;
    letter-spacing: 2px;
  }
}
.footerBrandingOnly .brandingDiv.brandingInfoOnlyLayout .brandLogo {
  margin-right: 0;
}
.footerBrandingOnly .showFooterspaceBetween {
  justify-content: space-between;
}`, "",{"version":3,"sources":["webpack://./src/Components/Partials/Footer/Footer.scss","webpack://./src/Styles/_colors.scss","webpack://./src/Styles/_mixins.scss"],"names":[],"mappings":"AACA;EACE,6BAAA;AAAF;AAEE;EACE,yBCDU;EDEV,kBAAA;EACA,iBAAA;EACA,cAAA;AAAJ;AAEI;EACE,iBAAA;EACA,cAAA;EACA,aAAA;EACA,0CAAA;EACA,cAAA;EAAA,SAAA;AAAN;AEHE;EFFE;IAQI,8BAAA;IACA,SAAA;EACN;EAEI;IAEI,iBAAA;EACR;AAJF;AAQI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AADN;AEzBE;EFuBE;IAMI,SAAA;EAAN;AACF;AAEM;EACE,eAAA;EACA,gBAAA;EACA,cCmCS;EDlCT,yBAAA;EACA,qBAAA;EACA,YAAA;AAAR;AEtCE;EFgCI;IASI,eAAA;IACA,YAAA;EACR;AACF;AAEM;EACE,YAAA;AAAR;AAGM;EACE,eAAA;EACA,gBAAA;EACA,cCcS;ADfjB;AAIM;EACE,eAAA;EACA,cCUS;EDTT,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,2BAAA;AAFR;AAIQ;EACE,cC/DW;AD6DrB;AAKQ;EACE,qBAAA;EACA,cAAA;AAHV;AASE;EACE,yBC/EU;EDgFV,aAAA;EACA,6BAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;AAPJ;AEvEE;EFsEA;IAWI,8BAAA;IACA,SAAA;EANJ;AACF;AAQI;EACE,eAAA;EACA,cC3BW;ADqBjB;AEjFE;EFqFE;IAKI,kBAAA;EALN;AACF;AAQI;EACE,aAAA;EACA,SAAA;AANN;AAQM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;AANR;AAQQ;EACE,WAAA;EACA,YAAA;AANV;AASQ;EACE,yBC1DO;ED2DP,qBCvHW;ADgHrB;;AAcA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAXF;;AElHE;EFiIA;IACE,kCAAA;EAXF;EAcA;IACE,kCAAA;EAZF;EAeA;IACE,mCAAA;EAbF;EAgBA;;;IAGE,mCAAA;EAdF;AACF;AAiBA;EACE,yBAAA;EAAA,sDAAA;EACA,cC9JY;AD+Id;AEvIE;EFoJF;IAKI,uDAAA;IAAA,0FAAA;EAdF;AACF;AAgBE;EACE,aAAA;AAdJ;AE/IE;EF4JA;IAII,cAAA;IACA,oBAAA;EAbJ;AACF;AAeI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,2BAAA;EACA,eAAA;AAbN;AAeM;EACE,mBAAA;AAbR;AEtKE;EF0KE;IAaI,SAAA;IACA,uBAAA;EAbN;AACF;AAgBI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AAdN;AAgBM;EACE,cCrMM;EDsMN,qBAAA;AAdR;AAgBQ;EACE,0BAAA;AAdV;AAmBI;EACE,uBAAA;EACA,cChNQ;EDiNR,eAAA;EACA,eAAA;EACA,yBAAA;AAjBN;AAmBM;EACE,0BAAA;AAjBR;AAsBE;EACE,uBAAA;EACA,cC7NU;ED8NV,eAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,yBAAA;EACA,0BAAA;EAAA,kBAAA;AApBJ;AAsBI;EACE,0BAAA;AApBN;AAwBE;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;AAtBJ;AEpNE;EFmOA;IAUI,uBAAA;IACA,sBAAA;IACA,MAAA;IACA,iBAAA;EArBJ;AACF;AAuBI;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,cAAA;AArBN;AAwBI;EACE,aAAA;EACA,qBAAA;EACA,SAAA;AAtBN;AEvOE;EF0PE;IAMI,aAAA;EArBN;AACF;AAuBM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AArBR;AAuBQ;EACE,cClRI;EDmRJ,qBAAA;AArBV;AAuBU;EACE,0BAAA;AArBZ;AA0BM;EACE,uBAAA;EACA,cC7RM;ED8RN,eAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;AAxBR;AA0BQ;EACE,0BAAA;AAxBV;AA6BI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;AA3BN;AA8BI;EACE,aAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,QAAA;AA5BN;AElRE;EFwSE;IASI,eAAA;EA3BN;AACF;AA8BI;EACE,eAAA;EACA,gBAAA;EACA,cChUQ;EDiUR,WAAA;EACA,YAAA;AA5BN;AA8BM;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AA5BR;AAgCI;EACE,iBAAA;EACA,gBAAA;EACA,gBAAA;AA9BN;AAiCI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,WAAA;AA/BN;AAiCM;EACE,WAAA;EACA,yBAAA;AA/BR;AEnTE;EFgVI;IAKI,mBAAA;IACA,mBAAA;IACA,cAAA;IACA,QAAA;IACA,WAAA;EA9BR;AACF;AAwCI;EACE,aAAA;EACA,+CAAA;EACA,qBAAA;EAAA,gBAAA;EACA,mBAAA;EACA,wBAAA;AAtCN;AEnUE;EFoWE;IAQI,aAAA;IACA,mBAAA;IACA,8BAAA;IACA,SAAA;EArCN;AACF;AAuCM;EACE,mBAAA;EACA,2BAAA;EACA,eAAA;EACA,YAAA;AArCR;AAuCQ;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,cAAA;AArCV;AAyCM;EACE,iBAAA;EACA,iBAAA;AAvCR;AE3VE;EFgYI;IAKI,sBAAA;IACA,MAAA;IACA,eAAA;IACA,mBAAA;EAtCR;AACF;AAyCM;EACE,eAAA;AAvCR;AA4CE;EACE,8BAAA;AA1CJ","sourcesContent":["@import \"src/Styles/theme.scss\";\n.footer {\n  border-top: 1px solid $color-gray-100;\n\n  .mainFooter {\n    background-color: $color-white;\n    padding: 30px 20px;\n    max-width: 1200px;\n    margin: 0 auto;\n\n    .footerContent {\n      max-width: 1200px;\n      margin: 0 auto;\n      display: grid;\n      grid-template-columns: 1.5fr 1fr 1fr 1.2fr;\n      gap: 40px;\n\n      @include respond-md {\n        grid-template-columns: 1fr 1fr;\n        gap: 20px;\n      }\n\n      > :first-child {\n        @include respond-md {\n          grid-column: 1 / -1;\n        }\n      }\n    }\n\n    .footerCol {\n      display: flex;\n      flex-direction: column;\n      gap: 15px;\n\n      @include respond-sm {\n        gap: 10px;\n      }\n\n      h3 {\n        font-size: 16px;\n        font-weight: 700;\n        color: $color-gray-900;\n        text-transform: uppercase;\n        letter-spacing: 0.5px;\n        height: 35px;\n\n        @include respond-sm {\n          font-size: 14px;\n          height: auto;\n        }\n      }\n\n      .footerBrandLogo img {\n        height: 35px;\n      }\n\n      .description {\n        font-size: 14px;\n        line-height: 1.6;\n        color: $color-gray-600;\n      }\n\n      .linkItem {\n        font-size: 14px;\n        color: $color-gray-700;\n        text-decoration: none;\n        cursor: pointer;\n        line-height: 1.4;\n        transition: color 0.2s ease;\n\n        &:hover {\n          color: $color-primary-pink;\n        }\n\n        a {\n          text-decoration: none;\n          color: inherit;\n        }\n      }\n    }\n  }\n\n  .subFooter {\n    background-color: $color-white;\n    padding: 20px;\n    border-top: 1px solid $color-gray-100;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    max-width: 1200px;\n    margin: 0 auto;\n\n    @include respond-md {\n      flex-direction: column-reverse;\n      gap: 20px;\n    }\n\n    .copyright {\n      font-size: 13px;\n      color: $color-gray-500;\n\n      @include respond-md {\n        text-align: center;\n      }\n    }\n\n    .socialLinks {\n      display: flex;\n      gap: 12px;\n\n      .logoContainer {\n        width: 40px;\n        height: 40px;\n        border-radius: 50%;\n        border: 1px solid $color-gray-300;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        transition: all 0.2s ease;\n\n        svg{\n          width: 20px;\n          height: 20px;\n        }\n\n        &:hover {\n          background-color: $color-gray-100;\n          border-color: $color-primary-pink;\n        }\n      }\n    }\n  }\n}\n\n.footerErrorMessage{\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n@include respond-md {\n  body.rewardListingMobileTabsActive .footerBrandingOnly {\n    --mobile-fixed-footer-offset: 70px;\n  }\n\n  body.rewardDetailMobileActionActive .footerBrandingOnly {\n    --mobile-fixed-footer-offset: 90px;\n  }\n\n  body.rewardDetailMobileCompletedActionActive .footerBrandingOnly {\n    --mobile-fixed-footer-offset: 120px;\n  }\n\n  body.rewardDetailMobileActionExpanded .footerBrandingOnly,\n  body.rewardDetailGiftCardAmountSheetActive .footerBrandingOnly,\n  body.rewardDetailMobileRecipientSheetActive .footerBrandingOnly {\n    --mobile-fixed-footer-offset: 240px;\n  }\n}\n\n.footerBrandingOnly{\n  background-color: var(--footerBrandingOnlyBg, $stroke-dark);\n  color: $color-white;\n\n  @include respond-md {\n    padding-bottom: calc(var(--mobile-fixed-footer-offset, 0px) + env(safe-area-inset-bottom));\n  }\n\n  .footerContactMobile {\n    display: none;\n    \n    @include respond-md {\n      display: block;\n      padding: 16px 20px 0;\n    }\n\n    .contactRow {\n      display: flex;\n      align-items: center;\n      gap: 20px;\n      margin-bottom: 12px;\n      justify-content: flex-start;\n      flex-wrap: wrap;\n\n      &:last-child {\n        margin-bottom: 16px;\n      }\n\n      @include respond-sm {\n        gap: 12px;\n        align-items: flex-start;\n      }\n    }\n\n    .contactItem {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      font-size: 14px;\n      \n      a {\n        color: $color-white;\n        text-decoration: none;\n        \n        &:hover {\n          text-decoration: underline;\n        }\n      }\n    }\n\n    .contactUsBtn {\n      background: transparent;\n      color: $color-white;\n      cursor: pointer;\n      font-size: 14px;\n      transition: all 0.3s ease;\n      \n      &:hover {\n        text-decoration: underline;\n      }\n    }\n  }\n\n  .customerSupport {\n    background: transparent;\n    color: $color-white;\n    cursor: pointer;\n    font-size: 14px;\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    transition: all 0.3s ease;\n    width: fit-content;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n\n  .brandingDiv {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    padding: 12px;\n    width: 100%;\n    max-width: 1200px;\n    margin : 0 auto;\n\n    @include respond-md {\n      justify-content: center;\n      flex-direction: column;\n      gap: 0;\n      padding: 4px 12px;\n    }\n\n    .brandingLogoSection {\n      display: flex;\n      align-items: center;\n      justify-content: flex-start;\n      flex-shrink: 0;\n    }\n\n    .footerContactDesktop {\n      display: flex;\n      align-items: flex-end;\n      gap: 24px;\n      \n      @include respond-md {\n        display: none;\n      }\n\n      .contactItem {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        font-size: 14px;\n        \n        a {\n          color: $color-white;\n          text-decoration: none;\n          \n          &:hover {\n            text-decoration: underline;\n          }\n        }\n      }\n\n      .contactUsBtn {\n        background: transparent;\n        color: $color-white;\n        cursor: pointer;\n        font-size: 14px;\n        transition: all 0.3s ease;\n        margin-left: 8px;\n        \n        &:hover {\n          text-decoration: underline;\n        }\n      }\n    }\n\n    .poweredByContainer {\n      display: flex;\n      align-items: center;\n      gap: 4px;\n      white-space: nowrap;\n    }\n\n    .poweredBy {\n      display: flex;\n      width: 100%;\n      justify-content: flex-end;\n      align-items: center;\n      font-size: 12px;\n      gap: 4px;\n      \n      @include respond-md {\n        font-size: 10px;\n      }\n    }\n\n    .whiteAdentoText {\n      font-size: 20px;\n      font-weight: 700;\n      color: $color-white;\n      width: 90px;\n      height: 44px;\n\n      img {\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n      }\n    }\n\n    .brandLogo {\n      margin-right: 6px;\n      max-height: 40px;\n      max-width: 100px;\n    }\n\n    .brandingContent {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      gap: 8px;\n      width: 100%;\n\n      .poweredByContainer {\n        width: 100%;\n        justify-content: flex-end;\n\n        @include respond-md {\n          align-items: center;\n          flex-direction: row;\n          font-size: 8px;\n          gap: 4px;\n          width: auto;\n        }\n      }\n\n      // .poweredBy {\n      //   @include respond-md {\n      //     justify-content: center;\n      //   }\n      // }\n    }\n\n    &.brandingInfoOnlyLayout {\n      display: grid;\n      grid-template-columns: auto minmax(0, 1fr) auto;\n      column-gap: 32px;\n      align-items: center;\n      justify-content: stretch;\n\n      @include respond-md {\n        display: flex;\n        flex-direction: row;\n        justify-content: space-between;\n        gap: 12px;\n      }\n\n      .footerContactDesktop {\n        align-items: center;\n        justify-content: flex-start;\n        flex-wrap: wrap;\n        min-width: 0;\n\n        .contactBox {\n          display: flex;\n          flex-direction: column;\n          align-items: flex-start;\n          flex-shrink: 0;\n        }\n      }\n\n      .poweredByContainer {\n        justify-self: end;\n        margin-left: auto;\n\n        @include respond-md {\n          flex-direction: column;\n          gap: 0;\n          font-size: 10px;\n          letter-spacing: 2px;\n        }\n      }\n\n      .brandLogo {\n        margin-right: 0;\n      }\n    }\n  }\n\n  & .showFooterspaceBetween{\n    justify-content: space-between;\n  }\n}\n","// ====================================\n// 🎨 Color Variables\n// ====================================\n\n$color-white: #ffffff;\n$color-black: #000000;\n\n// Primary Colors\n$color-primary-pink: #EA2466;\n$color-secondary-pink: #F5437E;\n$color-primary-dark-grey: #383838;\n$color-primary-medium-grey: #4a4a4a;\n$color-primary-light-grey: #808080;\n$color-border-primary-grey: #e2e8f0;\n// $color-border-primary-grey: #b4b4b4;\n$color-text-grey: #616161;\n\n// Background Colors\n$bg-pink-10: #FDECF2; // approximated 10% of #EA2466\n$bg-white: #FFFFFF;\n$bg-light-grey-1: #E8E8E8;\n$bg-light-grey-2: #F7F7F7;\n$bg-light-grey-3: #EDEDED;\n\n// Misc Colors\n$color-green: #00A664;\n$color-yellow: #FECE00;\n$color-red: #EB0000;\n$border-color-light-grey: #DCDCDC;\n\n// Stroke Colors\n$stroke-pink: #E11F60;\n$stroke-black: #000000;\n$stroke-dark: #1E1E1E;\n$stroke-grey: #E5E5E5;\n\n// Hover Colors\n$hover-pink: #CB104E;\n$hover-dark-grey: #484848;\n// $hover-light-grey: #EDEDED;\n\n// ====================================\n// ****** Precious Metals Theme *******\n// ====================================\n\n// Base Colors--\n$color-foreground: #252525;\n$color-primary: #030213;\n$color-secondary: #f2f1fc;\n$color-muted: #ececf0;\n$color-muted-foreground: #717182;\n$color-accent: #e9ebef;\n$color-destructive: #d4183d;\n$color-border: rgba(0, 0, 0, 0.1);\n$color-input: transparent;\n$color-input-background: #f3f3f5;\n$color-switch-background: #cbced4;\n$color-ring: #b50000;\n\n// Chart Colors--\n$chart-1: #f18b00;\n$chart-2: #3a9ac3;\n$chart-3: #6d91db;\n$chart-4: #f2ab00;\n$chart-5: #f9a800;\n\n// Gray Scale--\n$color-gray-50: #f9fafb;\n$color-gray-100: #f3f4f6;\n$color-gray-200: #e5e7eb;\n$color-gray-300: #d1d5db;\n$color-gray-400: #9ca3af;\n$color-gray-500: #6b7280;\n$color-gray-600: #4b5563;\n$color-gray-700: #374151;\n$color-gray-800: #1f2937;\n$color-gray-900: #111827;\n$color-gray-950: #030712;\n\n// Gold Colors\n$color-gold-50: #fffbeb;\n$color-gold-100: #fef3c7;\n$color-gold-200: #fde68a;\n$color-gold-300: #fcd34d;\n$color-gold-400: #fbbf24;\n$color-gold-500: #f59e0b;\n$color-gold-600: #d97706;\n$color-gold-700: #b45309;\n$color-gold-800: #92400e;\n$color-gold-900: #78350f;\n\n// Silver Colors\n$color-silver-50: #f8fafc;\n$color-silver-100: #f1f5f9;\n$color-silver-200: #e2e8f0;\n$color-silver-300: #cbd5e1;\n$color-silver-400: #94a3b8;\n$color-silver-500: #64748b;\n$color-silver-600: #475569;\n$color-silver-700: #334155;\n$color-silver-800: #1e293b;\n$color-silver-900: #0f172a;\n\n// Blue Colors\n$color-blue-50: #eff6ff;\n$color-blue-100: #dbeafe;\n$color-blue-200: #bfdbfe;\n$color-blue-300: #93c5fd;\n$color-blue-400: #60a5fa;\n$color-blue-500: #3b82f6;\n$color-blue-600: #2563eb;\n$color-blue-700: #1d4ed8;\n$color-blue-800: #1e40af;\n$color-blue-900: #1e3a8a;\n\n// Green Colors (Additional to system green)\n$color-green-50: #f0fdf4;\n$color-green-100: #dcfce7;\n$color-green-200: #bbf7d0;\n$color-green-300: #86efac;\n$color-green-400: #4ade80;\n$color-green-500: #22c55e;\n$color-green-600: #00A664;\n$color-green-700: #15803d;\n$color-green-800: #166534;\n$color-green-900: #14532d;\n\n// Red Colors (Additional to system red)\n$color-red-50: #fef2f2;\n$color-red-100: #fee2e2;\n$color-red-200: #fecaca;\n$color-red-300: #fca5a5;\n$color-red-400: #f87171;\n$color-red-500: #ef4444;\n$color-red-600: #EB0000;\n$color-red-700: #b91c1c;\n$color-red-800: #991b1b;\n$color-red-900: #7f1d1d;\n\n// Purple Colors\n$color-purple-50: #f5f3ff;\n$color-purple-100: #f3e8ff;\n$color-purple-200: #e9d5ff;\n$color-purple-300: #d8b4fe;\n$color-purple-400: #c084fc;\n$color-purple-500: #a855f7;\n$color-purple-600: #9333ea;\n$color-purple-700: #7c3aed;\n$color-purple-800: #6b21a8;\n$color-purple-900: #581c87;\n\n// Indigo Colors\n$color-indigo-50: #eef2ff;\n$color-indigo-100: #e0e7ff;\n$color-indigo-200: #c7d2fe;\n$color-indigo-300: #a5b4fc;\n$color-indigo-400: #818cf8;\n$color-indigo-500: #6366f1;\n$color-indigo-600: #4f46e5;\n$color-indigo-700: #4338ca;\n$color-indigo-800: #3730a3;\n$color-indigo-900: #312e81;\n\n// yellow Colors\n$color-yellow-50: #fefce8;\n$color-yellow-100: #fef9c3;\n$color-yellow-200: #fef08a;\n$color-yellow-300: #fde047;\n$color-yellow-400: #facc15;\n$color-yellow-500: #eab308;\n$color-yellow-600: #ca8a04;\n$color-yellow-700: #a16207;\n$color-yellow-800: #854d0e;\n$color-yellow-900: #713f12;\n\n// Orange Colors\n$color-orange-50: #fff7ed;\n$color-orange-100: #ffedd5;\n$color-orange-200: #fed7aa; \n$color-orange-300: #fdba74;\n$color-orange-400: #fb923c;\n$color-orange-500: #f97316;\n$color-orange-600: #ea580c;\n$color-orange-700: #c2410c;\n$color-orange-800: #9a3412;\n$color-orange-900: #7c2d12;\n\n// pink Colors\n$color-pink-50: #fdf2f8;\n$color-pink-100: #fce7f3;\n$color-pink-200: #fbcfe8;\n$color-pink-300: #f9a8d4;\n$color-pink-400: #f472b6;\n$color-pink-500: #ec4899;\n$color-pink-600: #db2777;\n$color-pink-700: #be185d;\n$color-pink-800: #9d174d;\n$color-pink-900: #831843;\n","@import './breakpoints';\n\n// ====================================\n// 📱 Media Query Mixins\n// ====================================\n@mixin respond-sm {\n  @media (max-width: $breakpoint-sm) {\n    @content;\n  }\n}\n\n@mixin respond-md {\n  @media (max-width: $breakpoint-md) {\n    @content;\n  }\n}\n\n@mixin respond-lg {\n  @media (max-width: $breakpoint-lg) {\n    @content;\n  }\n}\n\n@mixin respond-xlg {\n  @media (max-width: $breakpoint-xlg) {\n    @content;\n  }\n}\n\n@mixin respond-xxlg {\n  @media (max-width: $breakpoint-xxlg) {\n    @content;\n  }\n}\n\n@mixin respond-xxxlg {\n  @media (max-width: $breakpoint-xxxlg) {\n    @content;\n  }\n}\n\n@mixin respond-max {\n  @media (max-width: $breakpoint-max) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
